import { z } from "zod/v4";

export const InsertTypeList = [
  "beforebegin",
  "afterbegin",
  "beforeend",
  "afterend",
] as const;

export type InsertType = (typeof InsertTypeList)[number];

export const OnsiteEditTypeList = ["html", "text", "image", "hide"] as const;
export type OnsiteEditType = (typeof OnsiteEditTypeList)[number];

export const OnsiteEditDtoSchema = z.object({
  id: z.uuid().describe("Unique identifier for the onsite edit"),
  onsiteEditType: z
    .enum(OnsiteEditTypeList)
    .nullish()
    .describe(
      "Type of edit: 'html' (replace HTML), 'text' (replace text), 'image' (replace image), 'hide' (hide element)"
    ),
  variationId: z.uuid().describe("Variation this edit belongs to"),
  find: z
    .string()
    .nullable()
    .describe(
      "Text or HTML to find on the page (supports regex if isRegex=true)"
    ),
  title: z.string().nullish().describe("Display title for this edit"),
  isRegex: z
    .boolean()
    .default(false)
    .describe("Whether 'find' field contains a regular expression"),
  replace: z
    .string()
    .default("")
    .describe("New content to replace the found content with"),
  querySelectors: z
    .string()
    .array()
    .default([""])
    .describe(
      "CSS selectors to target specific elements (e.g., '.product-title', '#header')"
    ),
  skip: z
    .boolean()
    .default(false)
    .describe("Whether to skip applying this edit"),
  remove: z
    .boolean()
    .default(false)
    .describe("Whether to completely remove the element instead of replacing"),
  groupId: z
    .string()
    .optional()
    .describe("Group ID for organizing related edits"),
  /**
   * @deprecated // use onsiteEditType instead
   */
  isHtml: z.boolean().default(false),
  /**
   * @deprecated // use onsiteEditType instead
   */
  isImage: z.boolean().default(false),
  insertType: z
    .enum(InsertTypeList)
    .nullable()
    .describe(
      "Where to insert content: 'beforebegin', 'afterbegin', 'beforeend', 'afterend'"
    ),
  createdAtUrl: z
    .string()
    .optional()
    .nullable()
    .describe("URL where this edit was created"),
  createdAtTs: z
    .number()
    .nullish()
    .describe("Timestamp when this edit was created"),
});
export type OnsiteEditDto = z.infer<typeof OnsiteEditDtoSchema>;
